import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getAndroidBoxesLookup = createAsyncThunk('getAndroidBoxesLookup',
    async (filters, { dispatch }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingAndroidBoxesLookup())

        var myHeaders = new Headers()
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify(filters)
        }

        fetch(domainUrl + `/androidBoxesLookUps`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) 
                    dispatch(androidBoxesLookupResponse(result?.data))
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
                dispatch(androidBoxesLookupResponse([]))
            })
    }
)
export const getAndroidBoxPortals = createAsyncThunk('getAndroidBoxPortals',
    async (ID, { dispatch }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingAndroidBoxPortals())

        var myHeaders = new Headers()
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        }

        fetch(domainUrl + `/getPortals/`+ID, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) 
                    dispatch(androidBoxPortalsResponse(result?.data))
                else 
                    throw result?.message
            })
            .catch(error => { 
                message.error(error) 
                dispatch(androidBoxPortalsResponse([]))
            })
    }
)

const MasterPortal = createSlice({
    name: 'masterPortal',
    initialState: {
        data: null,
        androidBoxesLoading: false,
        androidBoxesLookup:[],
        androidBoxPortalsLoading: false,
        androidBoxPortals:[]
    },
    reducers: {
        gettingAndroidBoxesLookup: state => {
            state.androidBoxesLoading=true
        },
        androidBoxesLookupResponse: (state, action)=>{
            state.androidBoxesLookup= action.payload
            state.androidBoxesLoading= false
        },
        gettingAndroidBoxPortals: state => {
            state.androidBoxPortalsLoading=true
        },
        androidBoxPortalsResponse: (state, action)=>{
            state.androidBoxPortals= action.payload
            state.androidBoxPortalsLoading= false
        },
    },
})
export const { gettingAndroidBoxesLookup, androidBoxesLookupResponse, gettingAndroidBoxPortals, androidBoxPortalsResponse} = MasterPortal.actions;
export default MasterPortal.reducer